module.exports = __webpack_public_path__ + "static/1-0cd1f40d2b6b2a312e88218601c2779a.png";